var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Autocomplete, Button, CircularProgress, debounce, InputBase, Stack } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import { useCallback, useEffect, useRef } from 'react';
import { ChevronDownIcon } from '../../../../assets/customIcons';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { Search } from '../../../assets/svg';
import { deleteState } from '../../../../redux/crudSlice';
var moreButtonId = 'search-more';
export default function GridSearchSelect(props) {
    var _this = this;
    var _crud$apiKey;
    var crud = useAppSelector(function (state) { return state.crud; });
    var id = props.id, value = props.value, field = props.field, colDef = props.colDef, error = props.error, className = props.className, startAdornment = props.startAdornment, tabIndex = props.tabIndex, row = props.row;
    var _a = colDef.apiKey, apiKey = _a === void 0 ? "".concat(field, "_list") : _a, apiRequest = colDef.apiRequest, _b = colDef.valueOptions, valueOptions = _b === void 0 ? ((_crud$apiKey = crud[apiKey]) === null || _crud$apiKey === void 0 ? void 0 : _crud$apiKey.data) || [] : _b, getOptionLabel = colDef.getOptionLabel, _c = colDef.getOptionKey, getOptionKey = _c === void 0 ? function (op) { return op === null || op === void 0 ? void 0 : op.id; } : _c, moreButtonText = colDef.moreButtonText, isOptionEqualToValue = colDef.isOptionEqualToValue, multiple = colDef.multiple, renderOption = colDef.renderOption, placeholder = colDef.placeholder, getListData = colDef.getListData, onMoreButtonClick = colDef.onMoreButtonClick, filterOptions = colDef.filterOptions;
    var loadingKey = "isLoading".concat(apiKey);
    var loading = crud[loadingKey] === 'loading';
    var gridApi = useGridApiContext();
    var inputRef = useRef(null);
    var dispatch = useAppDispatch();
    useEffect(function () {
        return function () {
            dispatch(deleteState({
                key: apiKey
            }));
        };
    }, []);
    var handleChange = useCallback(function (event, newValue) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, gridApi.current.setEditCellValue({
                        id: id,
                        field: field,
                        value: newValue
                    }, event)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [gridApi]);
    var onOpen = function () { return __awaiter(_this, void 0, void 0, function () {
        var _crud$apiKey2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!((_crud$apiKey2 = crud[apiKey]) !== null && _crud$apiKey2 !== void 0 && _crud$apiKey2.data) && getListData)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getListData({
                            key: apiKey,
                            state: row,
                            request: apiRequest
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleInputChange = useCallback(debounce(function (e, val, details) {
        if (details !== 'reset' && getListData) {
            getListData({
                key: apiKey,
                request: _objectSpread(_objectSpread({}, apiRequest), {}, {
                    search: val
                }),
                state: row
            });
        }
    }, 500), [apiKey, row]);
    return /*#__PURE__*/ React.createElement(Autocomplete, {
        fullWidth: true,
        autoHighlight: true,
        filterSelectedOptions: true,
        value: value,
        className: className + " ".concat(error ? 'Mui-error' : ''),
        tabIndex: tabIndex,
        onChange: handleChange,
        options: valueOptions !== null && valueOptions !== void 0 ? valueOptions : [],
        getOptionLabel: getOptionLabel,
        getOptionKey: getOptionKey,
        renderOption: renderOption,
        filterOptions: filterOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        renderGroup: function (params) { return [params.children, moreButtonText ? /*#__PURE__*/ React.createElement(Button, {
                id: moreButtonId,
                disableElevation: true,
                disableRipple: true,
                onClick: function (e) {
                    var _inputRef$current;
                    return onMoreButtonClick === null || onMoreButtonClick === void 0 ? void 0 : onMoreButtonClick(e, {
                        inputValue: (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value,
                        colDef: colDef,
                        row: row
                    });
                },
                sx: {
                    position: 'fixed',
                    bottom: 12,
                    borderRadius: 2,
                    px: 2,
                    ':hover': {
                        background: 'none'
                    }
                }
            }, moreButtonText) : null]; },
        groupBy: function (option) { return option ? 'More' : ''; },
        onInputChange: handleInputChange,
        onOpen: onOpen,
        popupIcon: loading ? /*#__PURE__*/ React.createElement(CircularProgress, {
            color: "inherit",
            size: 12
        }) : /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            fontSize: "small"
        }),
        sx: {
            px: 3,
            background: 'white'
        },
        slotProps: {
            popper: {
                anchorEl: gridApi.current.getCellElement(id, field),
                style: {
                    minWidth: 350
                },
                placement: 'bottom-start'
            }
        },
        ListboxProps: moreButtonText ? {
            sx: {
                position: 'relative',
                mb: 6,
                borderBottom: "1px solid",
                borderColor: 'secondary.100'
            }
        } : undefined,
        renderInput: function (params) { /*#__PURE__*/ return React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            height: "100%"
        }, /*#__PURE__*/ React.createElement(Search, {
            color: "secondary",
            fontSize: "small",
            sx: {
                mr: 1,
                height: 16,
                width: 16
            }
        }), /*#__PURE__*/ React.createElement(InputBase, _extends({
            inputRef: inputRef,
            autoFocus: true,
            fullWidth: true,
            id: params.id,
            error: error,
            placeholder: placeholder,
            inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
                autoComplete: 'new-password' // disable autocomplete and autofill
            })
        }, params.InputProps, {
            startAdornment: startAdornment
        }))); }
    });
}
